var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssistantLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3788 57.0785C49.7077 56.3256 58.7319 47.1733 59.4745 35.6837C59.6197 33.4353 59.6197 31.1066 59.4745 28.8582C58.7319 17.3686 49.7077 8.21643 38.3788 7.46336C34.5137 7.20644 30.4786 7.20698 26.6214 7.46336C15.2924 8.21643 6.26827 17.3686 5.52572 28.8582C5.38042 31.1066 5.38042 33.4353 5.52572 35.6837C5.79618 39.8684 7.64686 43.7429 9.82566 47.0146C11.0907 49.305 10.2558 52.1637 8.93814 54.6608C7.98806 56.4613 7.51302 57.3615 7.89443 58.0118C8.27587 58.662 9.12786 58.6829 10.8319 58.7243C14.2017 58.8064 16.474 57.8509 18.2778 56.5208C19.3007 55.7666 19.8123 55.3893 20.1648 55.346C20.5173 55.3026 21.2111 55.5884 22.5984 56.1598C23.8453 56.6733 25.2931 56.9902 26.6214 57.0785C30.4786 57.335 34.5137 57.3355 38.3788 57.0785Z",
    fill: "url(#paint0_linear_324_1289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 41.125L25.301 26.1597C25.5567 25.3925 26.2746 24.875 27.0833 24.875C27.892 24.875 28.61 25.3925 28.8657 26.1597L33.8542 41.125M41.9792 24.875V41.125M23.0208 35.7083H31.1458",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_1289",
    x1: 32.5001,
    y1: 7.27087,
    x2: 32.5001,
    y2: 58.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantLogo);
export default __webpack_public_path__ + "static/media/ai-assistant-logo.822713e8fec4a05f4a0999e5259eaf6f.svg";
export { ForwardRef as ReactComponent };